import { STATION_DESCRIPTION_WIDTH } from 'constants/map';
import styled, { css } from 'styled-components';
import { DescriptionContainer, DescriptionText, DescriptionWrapper } from '../../Description/Description.styled';
import { IconWrapper, tourActiveElementStyles } from '../../../Station.styled';

const tourActiveStyles = css`
    ${tourActiveElementStyles}
    ${IconWrapper} {
        position: relative;
    }
`;

const exapndedStationStyles = css`
    ${DescriptionText} {
        padding-left: 0.8rem;
    }
`;

const searchStationStyles = css`
    ${DescriptionText} {
        padding-left: 0.3rem;
    }
`;

export const BigJunctureSubStationWrapper = styled.div<{
    isMapTourActiveElement: boolean;
    isSearchStation: boolean;
    isDescriptionExpanded: boolean;
}>`
    display: flex;
    align-items: center;
    max-width: ${STATION_DESCRIPTION_WIDTH + 50}px;
    ${DescriptionWrapper} {
        position: initial;
    }

    ${DescriptionContainer} {
        position: initial;
        transform: unset;
    }

    ${DescriptionText} {
        padding-left: 0;
        margin-left: 0;
    }
    ${({ isMapTourActiveElement }) => isMapTourActiveElement && tourActiveStyles};
    ${({ isSearchStation }) => isSearchStation && searchStationStyles};
    ${({ isDescriptionExpanded }) => isDescriptionExpanded && exapndedStationStyles};
`;
